// ============================================
// FILE: apiSetup/apiConfig.ts
// ============================================

// Central API endpoint for school discovery
// export const CENTRAL_API_URL = 'http://localhost/skoolpillar-eps/';



// export const CENTRAL_API_URL = 'https://skoolpillar.space/skoolpillar-gateway/';

export const CENTRAL_API_URL = 'https://skoolpillar.space/skoolpillar-gateway-beta/';



// Function to get the dynamic API URL from localStorage
export const getApiBaseUrl = (): string => {
  const storedUrl = localStorage.getItem('API_BASE_URL');
  
  if (!storedUrl) {
    console.warn('⚠️ API_BASE_URL not found in localStorage, using fallback');
    // Fallback to localhost or redirect to school setup
    // return 'http://localhost/skoolpillar-eps/';

    return 'https://skoolpillar.space/skoolpillar-gateway-beta/';

  }
  
  // Ensure URL ends with /
  const url = storedUrl.endsWith('/') ? storedUrl : `${storedUrl}/`;
  console.log('✅ Using API URL:', url);
  return url;
};

// Export the dynamic URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to get school information
export const getSchoolInfo = () => {
  return {
    id: localStorage.getItem('SCHOOL_ID'),
    name: localStorage.getItem('SCHOOL_NAME'),
    apiUrl: localStorage.getItem('API_BASE_URL')
  };
};

// Helper function to check if school is configured
export const isSchoolConfigured = (): boolean => {
  const apiUrl = localStorage.getItem('API_BASE_URL');
  const schoolId = localStorage.getItem('SCHOOL_ID');
  return !!(apiUrl && schoolId);
};

// Helper function to clear school configuration
export const clearSchoolConfig = () => {
  localStorage.removeItem('API_BASE_URL');
  localStorage.removeItem('SCHOOL_ID');
  localStorage.removeItem('SCHOOL_NAME');
  console.log('🗑️ School configuration cleared');
};

// Helper function to set school configuration
export const setSchoolConfig = (schoolId: string, schoolName: string, apiUrl: string) => {
  localStorage.setItem('SCHOOL_ID', schoolId);
  localStorage.setItem('SCHOOL_NAME', schoolName);
  localStorage.setItem('API_BASE_URL', apiUrl);
  console.log('✅ School configuration saved:', { schoolId, schoolName, apiUrl });
};